import React from 'react'

import Banner from './Banner'

interface IErrorBanner {
  icon: JSX.Element
  message: string
  messageObject?: JSX.Element
}

const ErrorBanner = ({ message, icon, messageObject }: IErrorBanner) => (
  <Banner
    data-testid='error-banner'
    message={message}
    icon={icon}
    className='c-common-banner--error'
    messageObject={messageObject}
  />
)

export default ErrorBanner
